module.exports = __webpack_public_path__ + "static/media/EasyWords_web_1.c7a7e4df.jpg";